module.exports = __webpack_public_path__ + "static/media/biodiverse-cities-interreg-ns-vertical.d87e94e2.svg";